export const tareasRoutes = [
  {
    path: '/tareas',
    name: 'Tareas',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '@/modules/Core/views/Tareas/TareasIndex.vue'
      ),
    icon: 'InboxStackIcon',
    menu: true,
    desplegable: false,
    meta: {
      title: 'Tareas',
      requiresSession: true,
      permiso: [],
      perfiles: ['SUPERADMIN'],
      showBackButton: false
    },
    children: []
  }
]
